<template>
    <div class="modal-error">
        <div class="modal-error__content">
            <div class="modal-error__header">
                <button
                    class="modal-error__button-close btn btn-close"
                    @click="Catch_Error()"
                />
            </div>
            <div class="modal-error__body">
                <h1 class="modal-error__title">
                    500
                </h1>
                <h2 class="modal-error__subtitle">
                    Error interno del servidor
                </h2>
                <p class="modal-error__paragraph">
                    <span>¡Vaya parece que algo salió mal!</span>
                    Trata de volver a cargar esta estación.
                    Si el problema persiste no dudes en contactar con nosotros
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'ErrorScreen',

        methods:{
            ...mapActions('station_id',['Catch_Error'])
        }
    };
</script>


<style scoped lang="scss">
    .modal-error{
        align-items: center;
        background-color: $bg-light-color-transparent;
        display: flex;
        height: 100%;
        justify-content: center;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 2;

        &__content {
            background-color: $bg-light-color;
            padding: 1rem 2rem;
            border-radius: 1rem;
            border: .1rem solid $custom-color-transparent;
            width: 50%;
        }

        &__header {
            text-align: end;
        }

        &__body {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }

        &__title {
            text-align: center;
            color: $extra-color;
            margin: 0;
            width: 100%;
        }

        &__subtitle {
            width: 100%;
            text-align: center;
            margin: 0;
            color: $extra-color-transparent;
        }

        &__paragraph {
            margin-top: 1rem;
            display: flex;
            flex-wrap: wrap;
            text-align: justify;
            span {
                width: 100%;
            }
        }
    }
</style>